// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontPage_root__2Xcaz","introSection":"FrontPage_introSection__-cP--","logo":"FrontPage_logo__3eXrP","title":"FrontPage_title__2_t_M","userName":"FrontPage_userName__gxr8R"};